import type { ContactContent } from "./contact";

// Baked-in defaults — the exact copy the hardcoded Contact page shipped with.
export const defaultContactContent: ContactContent = {
  meta: {
    title: "Contact Quintara",
    description: "Tell us what you'd like to build on WhatsApp — a solutions lead replies within one business day.",
  },
  hero: {
    eyebrow: "Contact",
    heading: "Tell us what you'd like to build.",
    lede: "Share a few details and a solutions lead will reply within one business day.",
  },
  side: {
    email: "info@quintaratech.com",
    phone: "+971 55 803 9305",
    officeName: "Quintara Advertising Services L.L.C",
    officeLocation: "Dubai, United Arab Emirates",
    note: "Already a client with an urgent issue? Use the support channel in your onboarding pack for 24/7 incident response.",
  },
};
